import React from 'react';
import Iframe from 'react-iframe'

const linkPage = (props) => {
  return (
    <div className='content-panel'>
      <Iframe src={props.src}
      width="100%"
      height="100%"
      id="myId"
      frameBorder="0"
      allowFullScreen />
    </div>
  )
};

export default linkPage
